import React, { FC, useContext } from 'react';
import { Route } from 'react-router-dom';
import { AuthContext } from '../Auth';
import { RouteProps } from 'react-router';

type LoggedInRouteGuardProps = {
  component: React.ComponentType;
} & RouteProps;

type LoggedInRouteGuardComponent = React.FC<LoggedInRouteGuardProps>;

const RedirectComponent: FC = () => {
  globalThis.location.assign(`/login${globalThis.location.search ?? ''}`);
  return null;
};

export const LoggedInRouteGuard: LoggedInRouteGuardComponent = ({
  component: RouteComponent,
  ...rest
}) => {
  const { currentUser } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        currentUser ? <RouteComponent {...routeProps} /> : <RedirectComponent />
      }
    />
  );
};
